export default __webpack_public_path__ + "static/media/advancedReactPerformance.095fd391.md";